import styled from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

import { IProductsCount } from '../model';

import { fifteenPx } from '.';

function calculateMaxWidthForProducts(productsCount: number) {
  return `${100 / productsCount}%`;
}
export const ProductWrapper = styled.div<IProductsCount>`
  max-width: 50%;
  padding: calc(${fifteenPx} * 2) 0;

  @media (min-width: ${breakpoints.md}) {
    width: ${(props) => calculateMaxWidthForProducts(props.productsCount)};
    max-width: ${(props) => calculateMaxWidthForProducts(props.productsCount)};
    padding: calc(${fifteenPx} * 2) ${fifteenPx};
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 1rem;

  @media (min-width: ${breakpoints.sm}) {
    display: flex;
    text-align: inherit;
    padding-bottom: 0;
  }
`;
